// extracted by mini-css-extract-plugin
export default {"root":"w4x6A2ZthuwHbF4Wyk0F","width-160":"DsAZIqiQt6uuHBeKVH7O","width-240":"jeaMiqzWKdjqYA6wX9nO","width-360":"sCEwQ1ZhH1PqMijeKxlO"};